module.exports = __webpack_public_path__ + "static/media/malt.9fdc75b0.svg";